import React from 'react';
import ScrollWrapper from '../../../ScrollWrapper/ScrollWrapper';
import FaqBox from './FaqBox';
import InnerHtml from './InnerHtml';
import {
  FootNoteFirstInner,
  FootNoteMain,
  FootNoteNewStyle,
  FootNoteSecInner,
} from './styled';

export default function FootNoteNew(props) {
  const {
    content,
    faqsData,
    priceRateMerge,
    alsoSearchFor,
    screen,
    updatedOn,
    productId,
    priceTable,
    ratingTable,
  } = props;
  const date = new Date(updatedOn).toLocaleDateString('en-US');
  const rightSideDataPresent =
    priceRateMerge || faqsData?.length || alsoSearchFor || priceTable;
  const leftSideDataPresent = content;

  let faqsImpressionData = {
    category: 'impression_section_in_pdp',
    section_name: 'Faqs Section',
    sku_id: productId,
  };
  const faqsPresent = productId ? content?.includes('FAQs') : false;
  if (!faqsPresent) faqsImpressionData = null;

  return (
    <FootNoteMain margin={screen === 'pdp'}>
      {content ? (
        <FootNoteFirstInner
          flexBasis={
            leftSideDataPresent && !rightSideDataPresent
              ? '100%'
              : rightSideDataPresent && !leftSideDataPresent
                ? '0%'
                : '60%'
          }
        >
          <ScrollWrapper data={faqsImpressionData} threshold={0.2}>
            <FootNoteNewStyle
              dangerouslySetInnerHTML={{
                __html: content,
              }}
              changeTag={productId == 283}
            ></FootNoteNewStyle>
          </ScrollWrapper>
        </FootNoteFirstInner>
      ) : null}

      <FootNoteSecInner
        flexBasis={
          rightSideDataPresent && !leftSideDataPresent
            ? '100%'
            : leftSideDataPresent && !rightSideDataPresent
              ? '0%'
              : '40%'
        }
        leftPadding={
          !leftSideDataPresent || !rightSideDataPresent ? '0' : '40px'
        }
      >
        <FootNoteNewStyle>
          {priceRateMerge ? (
            <>
              <p className="tableHead">Product and Rating Table</p>
              <div
                dangerouslySetInnerHTML={{
                  __html: priceRateMerge,
                }}
              />
              {updatedOn ? <p> This data was last updated on {date}</p> : null}
            </>
          ) : (
            <>
              {priceTable ? (
                <InnerHtml
                  updatedOn={updatedOn}
                  heading={'Price List'}
                  data={priceTable}
                />
              ) : null}
              {ratingTable ? (
                <InnerHtml heading={'Rating'} data={ratingTable} />
              ) : null}
            </>
          )}

          {alsoSearchFor ? <InnerHtml data={alsoSearchFor} /> : null}
          {faqsData?.length ? <FaqBox faqsData={faqsData} /> : null}
        </FootNoteNewStyle>
      </FootNoteSecInner>
    </FootNoteMain>
  );
}
